"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FETCH_FAILURE = exports.FETCH_SUCCESS = exports.FETCH_REQUEST = void 0;
exports.FETCH_REQUEST = 'config/FETCH/REQUEST';
exports.FETCH_SUCCESS = 'config/FETCH/SUCCESS';
exports.FETCH_FAILURE = 'config/FETCH/FAILURE';
//# sourceMappingURL=types.js.map